// extracted by mini-css-extract-plugin
export default {"loader":"auth_loader__7KkbF"};